import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
import AuthContext from "../AuthContext";
import { keycloakRolesToUserRole } from "cresus-common";
const AuthProvider = (props) => {
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [email, setEmail] = useState();
    const [username, setUsername] = useState();
    const [userId, setUserId] = useState();
    const [role, setRole] = useState();
    useEffect(() => {
        fetch("/auth/me", { credentials: "include" })
            .then((res) => {
            if (!res.ok)
                throw new Error("Not authenticated");
            return res.json();
        })
            .then((user) => {
            var _a;
            setIsAuthenticated(true);
            setEmail(user.email);
            setUsername(user.name);
            setUserId(user.sub);
            setRole(keycloakRolesToUserRole((_a = user.roles) !== null && _a !== void 0 ? _a : []));
        })
            .catch(() => {
            setIsAuthenticated(false);
        });
    }, []);
    const handleLogout = () => {
        window.location.href = "/auth/logout";
    };
    const value = {
        isAuthenticated,
        email,
        userId,
        username,
        role,
        onLogout: handleLogout,
    };
    return (_jsx(AuthContext.Provider, Object.assign({ value: value }, { children: props.children })));
};
export default AuthProvider;
